import React from "react";
import Header from "./Header";
import "../css/custom.css";
import Footer from "./Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2, // Number of slides to show at once
  slidesToScroll: 1, // Number of slides to scroll at a time
  // You can add more settings and customize it further
};
function custom() {
  return (
    <div className="mainccc">
      {" "}
      <Header></Header>
      <div className="section0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4> Custom Website Design</h4>
              <p>
                Stand Out In This Saturated Digital Landscape With A Custom Fit
                Website
              </p>
              <a href="/#" className="btn btn-outline-primary">
                GET MY FREE PROPOSAL{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="section000 section0000 sec">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Why Your Business Needs A Custom Website Design</h1>
            </div>
            <div className="col-lg-6">
              <p>
                Your website is the backbone of your business. It supports all
                your company’s digital marketing efforts and serves as your
                primary customer touchpoint. A responsive, custom eCommerce
                website design gives online users a clear idea of your brand
                offerings, unique value propositions and core values.
                <br />
                According to a report released by the eCommerce Foundation, 88
                percent of U.S. consumers perform online research before making
                a purchase or visiting a local store. Without a professional
                custom website design, online shoppers can get easily
                frustrated. This results in an increased bounce rate, poor
                online reputation and lower conversion rate.
                <br />
                Don’t let this be the case for your business. Ensure your target
                customers can find and navigate your website with ease. Invest
                in a responsive, well-designed and informative website to
                improve your brand’s profitability and success.
              </p>
              <br />
            </div>
            <div className="col-lg-6">
              <img
                src="https://thriveagency.com/wp-content/themes/thrive-agency/images/website-banner-image-new.svg"
                alt=""
              />
            </div>
            <div className="col-12">
              <h1>
                Custom Fit Web Design vs. Website Templates: What’s Right for
                Your Business?
              </h1>
            </div>
            <div className="col-lg-6">
              <img
                src="https://thriveagency.com/wp-content/themes/thrive-agency/images/website-business-image-new.svg"
                alt=""
              />
            </div>
            <div className="col-lg-6">
              <p>
                Your website is the backbone of your business. It supports all
                your company’s digital marketing efforts and serves as your
                primary customer touchpoint. A responsive, custom eCommerce
                website design gives online users a clear idea of your brand
                offerings, unique value propositions and core values.
                <br />
                According to a report released by the eCommerce Foundation, 88
                percent of U.S. consumers perform online research before making
                a purchase or visiting a local store. Without a professional
                custom website design, online shoppers can get easily
                frustrated. This results in an increased bounce rate, poor
                online reputation and lower conversion rate.
                <br />
                Don’t let this be the case for your business. Ensure your target
                customers can find and navigate your website with ease. Invest
                in a responsive, well-designed and informative website to
                improve your brand’s profitability and success.
              </p>
              <br />
            </div>
            <div className="col-12">
              pA custom design website, on the other hand, allows you to
              establish and express your brand through tailored page elements
              that align with your objectives. Custom web design cost is
              relatively higher than website templates, but they offer numerous
              benefits that give you a competitive edge. A custom WordPress
              website design is more search engine-friendly, customer-centric,
              unique and scalable than built-in templates.
              <br />
              By choosing custom website design packages, you build a website
              around your specific customer journey and brand messaging.
            </div>
          </div>
        </div>
      </div>
      <div className="section5 section555 sectiono55">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>Custom Web Design Services</h4>
              <p className="p">
                100 Percent Unique, Professional Website Design for Your
                Business
              </p>
              <p>
                Technical SEO for WordPress and other CMS is critical to online
                success. With the right technical optimization SEO strategy in
                place, you can flag up website issues, take immediate action to
                resolve them and ensure all SEO elements are working properly.
                <br />
                Leverage our SEO services to your advantage and achieve
                profitable long-term growth. Here’s what you can expect when you
                partner with our technical SEO company:
              </p>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="caro">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Our Latest Web Design Projects</h2>
            </div>
            <div className="col-12">
              <div className="row">
                <Slider {...settings} className="slide">
                  <div className="col-4">
                    <div>
                      <img
                        src="https://miro.medium.com/v2/resize:fit:871/1*9YJw0zVY1pIK41eTErjzgQ.jpeg"
                        alt=""
                      />
                      <h3>Softroc</h3>
                    </div>
                  </div>
                  <div className="col-4">
                    <div>
                      <img
                        src="https://miro.medium.com/v2/resize:fit:871/1*9YJw0zVY1pIK41eTErjzgQ.jpeg"
                        alt=""
                      />
                      <h3>Softroc</h3>
                    </div>
                  </div>
                  <div className="col-4">
                    <div>
                      <img
                        src="https://miro.medium.com/v2/resize:fit:871/1*9YJw0zVY1pIK41eTErjzgQ.jpeg"
                        alt=""
                      />
                      <h3>Softroc</h3>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="award">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Award-Winning Web Design Company</h1>
              <img
                src="https://thriveagency.com/files/Badge-Website.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default custom;
